module.exports = __webpack_public_path__ + "assets/mention.5df7e86c.svg";